import React from "react";
import Spinner from "react-spinkit";
import SkeletonCard from "../skeleton-loader/SkeletonCard";
import SkeletonTable from "../skeleton-loader/SkeletonTable";
import SkeletonForm from "../skeleton-loader/SkeletonForm";
import SkeletonList from "../skeleton-loader/SkeletonList";
import SkeletonDashboard from "../skeleton-loader/SkeletonDashboard";
import SkeletonChart from "../skeleton-loader/SkeletonChart";
import SkeletonInterventionCard from "../skeleton-loader/SkeletonInterventionCard";
import SkeletonAssessmentTable from "../skeleton-loader/SkeletonAssessmentTable";
import SkeletonBenchmarksTable from "../skeleton-loader/SkeletonBenchmarksTable";
import SkeletonCaseLoadList from "../skeleton-loader/SkeletonCaseLoadList";
import SkeletonBlock from "../skeleton-loader/SkeletonBlock";

type Props = {
  evidenceDataTable?: boolean;
  type?: 'spinner' | 'card' | 'table' | 'form' | 'list' | 'dashboard' | 'chart' | 'intervention' | 'assessment-table' | 'benchmarks-table' | 'caseload-list' | 'block';
  cardCount?: number; // For SkeletonCard
  rows?: number; // For SkeletonTable
  columns?: number; // For SkeletonTable / SkeletonBenchmarksTable
  hasHeader?: boolean; // For SkeletonTable
  hasExtraInfo?: boolean; // For SkeletonTable
  filterCount?: number; // For SkeletonTable
  hasActionButton?: boolean; // For SkeletonTable / SkeletonAssessmentTable
  assessmentColumns?: number; // For SkeletonAssessmentTable
  hasActionBar?: boolean; // For SkeletonAssessmentTable
  hasFilters?: boolean; // For SkeletonBenchmarksTable
  hasLegend?: boolean; // For SkeletonBenchmarksTable
  hasAlertBadge?: boolean; // For SkeletonCaseLoadList
  width?: string | number; // For SkeletonBlock
  height?: string | number; // For SkeletonBlock
  minHeight?: string | number; // For SkeletonBlock
  borderRadius?: string | number; // For SkeletonBlock
  fieldCount?: number; // For SkeletonForm
  hasButton?: boolean; // For SkeletonForm
  itemCount?: number; // For SkeletonList
  hasAvatar?: boolean; // For SkeletonList
  variant?: 'bar' | 'line' | 'pie'; // For SkeletonChart
  barCount?: number; // For SkeletonChart
  animation?: 'pulse' | 'wave' | 'none';
};

// const LoadingIndicator = (props: Props) => {
//   return (
//     <div
//       data-cy="loading-indicator"
//       style={{ margin: "20px", minHeight: props.evidenceDataTable ? '65vh' : '0px' }}
//       className="d-flex justify-content-center align-items-center"
//     >
//       <Spinner name="circle" fadeIn="quarter" className="loadingIndicator" />
//     </div>
//   );
// };

// export default LoadingIndicator;


// LoadingIndicator.tsx - THE KEY COMPONENT

const LoadingIndicator = (props: Props) => {
  const { type = 'spinner', ...otherProps } = props;
  
  // Switch based on type prop
  const renderSkeleton = () => {
    switch (type) {
      case 'table':
        return <SkeletonTable {...otherProps} />;
      
      case 'card':
        return <SkeletonCard {...otherProps} />;
      
      case 'form':
        return <SkeletonForm {...otherProps} />;
      
      case 'list':
        return <SkeletonList {...otherProps} />;
      
      case 'dashboard':
        return <SkeletonDashboard {...otherProps} />;
      
      case 'chart':
        return <SkeletonChart {...otherProps} />;

      case 'intervention':
        return <SkeletonInterventionCard {...otherProps} />;

      case 'assessment-table':
        return <SkeletonAssessmentTable {...otherProps} />;

      case 'benchmarks-table':
        return <SkeletonBenchmarksTable {...otherProps} />;

      case 'caseload-list':
        return <SkeletonCaseLoadList {...otherProps} />;

      case 'block':
        return <SkeletonBlock {...otherProps} />;

      default:
        return <SkeletonBlock {...otherProps} />;
    }
  };
  
  return renderSkeleton();
};

export default LoadingIndicator;
